@if (bookingId() && endpoint()) {
<div class="o-grid u-push-b">
  <div class="o-grid__col o-grid__col--full">
    <core-card>
      <h2 class="u-text u-fz--600 u-push-b">
        {{ 'bookingsView.bookingDetails' | translate }}
      </h2>
      <core-data-list [items]="bookingDataList()" class="c-booking__details" />

      @if (routeSummary(); as route) {
      <div class="u-push-t">
        <p class="c-data-list-item__key"
          style="--_key-fz: var(--fz-100); --_key-fw: 600; --_key-color: var(--color-neutral-800)">
          {{ 'bookingsView.routeTitle' | translate }}
        </p>

        @if (!route.requiresTransshipment) {
        <p class="u-text u-fw-bold" style="--text-fz: var(--fz-300)">{{ route.directPath }}</p>
        <p class="u-text--xs" style="--text-color: var(--color-neutral-600)">{{ route.firstLegLabel || ('common.na' |
          translate) }}</p>
        } @else {
        <p class="u-text u-fw-bold" style="--text-fz: var(--fz-300)">{{ route.transshipmentPath }}</p>
        <p class="u-text--xs u-fw-bold" style="--text-color: var(--color-neutral-800)">
          {{ route.connectionTypeLabelKey | translate }}
        </p>
        <p class="u-text--xs" style="--text-color: var(--color-neutral-600)">{{ route.transshipmentLegs }}</p>
        }
      </div>
      }
    </core-card>
  </div>
</div>

<nav core-generic-tabs [config]="tabsConfig()" [activeTabId]="activeTabIdValue()" (tabChange)="onTabChange($event)">
</nav>

<core-generic-table [createButtonText]="'bookingsView.addItem' | translate"
  [class.u-hide]="activeTab()?.id !== 'booking_items'" [dataInput]="bookingsItems()" [endpoint]="endpoint()"
  [listTitle]="'bookingsView.title' | translate: {bookingCode: bookingCode()}" [columns]="columns"
  [modalFields]="modalFields()" [actions]="actions" [globalActions]="globalActions" [showFilter]="false"
  [showSelection]="false" [showActions]="true" [showCreateButton]="true" [enablePagination]="true"
  [modelFactory]="bookingsItemsModelFactory" [moreData]="moreData" (onMoreDataLoaded)="onMoreDataLoaded($event)"
  (dataCreated)="onDataChanges($event)" (dataUpdated)="onDataChanges($event)" (dataDeleted)="onDataChanges()"
  (dataFetched)="onDataFetched($event)" (beforeSave)="onBeforeSave($event)"
  (formReady)="bookingItemModalForm.set($event)" class="o-layout__section" />

<core-card class="u-push-t" [class.u-hide]="activeTab()?.id !== 'attachments'">
  <core-generic-documentation [documents]="bookingAttachments()" [config]="attachmentsConfig()"
    [permissions]="attachmentsPermissions"
    (actionTriggered)="onAttachmentsActionTriggered($event)"></core-generic-documentation>
</core-card>
}


<ng-template #chasisTemplate let-row let-column="column">
  @if (!row.chasis || row.chasis.length === 0) {
  <span class="c-tag">{{ ' - ' }}</span>
  } @else if(row.chasis.length > 1){
  <span class="c-tag">{{ 'bookings.chasisAttached' | translate }}</span>
  } @else {
  <span class="c-tag">{{ row.chasis }}</span>
  }
</ng-template>

<ng-template #revenueFieldTemplate let-value="value" let-data="data" let-mode="mode" let-errors="errors"
  let-formValue="formValue">
  <div class="c-entry-group bookings-view-revenue-template">
    <div coreDynamicField [field]="revenueInputFieldConfig()" [value]="value" [mode]="mode"
      [errors]="resolveRevenueErrors(errors)" [rowData]="data" [formValue]="formValue"
      (valueChange)="syncRevenueField(data, $event)" (onBlurEvent)="syncRevenueField(data, value, true)">
    </div>
    <core-generic-button [config]="{
        type: ButtonType.LINK_UNDERLINED,
        text: ('bookingsView.obtainSuggestedRevenue' | translate),
        disabled: !data?.cargoType || isSuggestingRevenue(data),
        loading: isSuggestingRevenue(data)
      }" (buttonClick)="suggestRevenue($event.originalEvent, data)">
    </core-generic-button>
  </div>
</ng-template>

<ng-template #clientRateTemplate let-row let-column="column">
  @if (row.clientRateDetails || row.clientRate) {
  <div class="c-rate-link">
    <p class="u-text u-fw-bold">
      {{ 'bookingsView.linkedRate' | translate }}:
      {{ formatClientRateReference(row) }}
    </p>
    @if (row.clientRateDetails?.version !== undefined && row.clientRateDetails?.version !== null) {
    <p class="u-text--xs">
      {{ 'rates.version' | translate }}: v{{ row.clientRateDetails.version }}
    </p>
    }
    @if (row.clientRateDetails?.isActive === false) {
    <p class="u-text--xs">
      {{ 'rates.historical' | translate }}
    </p>
    }
  </div>
  } @else {
  <span class="c-tag">{{ 'common.na' | translate }}</span>
  }
</ng-template>
